<div class="register-complete">
  <div class="register-complete__missing-fields-prompt">
    <div style="padding-top: 5px">
      <span class="register-complete__warn-icon" nz-icon nzType="ng-zorro:warn"></span>
    </div>
    <div class="register-complete__missing-fields-prompt__text">
      <p>
        We couldn't retrieve all the required information, Please complete the
        missing fields.
      </p>
    </div>
  </div>

  <nz-divider nzText="" class="register-complete__divider"></nz-divider>

  <form
    nz-form
    [formGroup]="validateForm"
    (ngSubmit)="submitForm()"
    class="register-complete__form"
    autocomplete="off"
  >
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <div class="register-complete__form-item">
          <label class="register-complete__label">First Name</label>
          <nz-input-group>
            <input
              nz-input
              nzType="primary"
              placeholder="Name"
              formControlName="firstName"
              class="register-complete__input beta"
              [ngClass]="{
                'border-error': f['firstName'].invalid && f['firstName'].touched,
              }"
            />
          </nz-input-group>
          <div
            *ngIf="f['firstName'].invalid && f['firstName'].touched"
            class="register-complete__form__error"
          >
            * Please enter your first name
          </div>
        </div>
      </div>
      <div nz-col nzSpan="12">
        <div class="register-complete__form-item">
          <label class="register-complete__label">Last Name</label>
          <nz-input-group>
            <input
              nz-input
              nzType="primary"
              placeholder="Lastname"
              formControlName="lastName"
              class="register-complete__input beta"
              [ngClass]="{
                'border-error': f['lastName'].invalid && f['lastName'].touched,
              }"
            />
          </nz-input-group>
          <div
            *ngIf="f['lastName'].invalid && f['lastName'].touched"
            class="register-complete__form__error"
          >
            * Please enter your last name
          </div>
        </div>
      </div>
    </div>

    <div class="register-complete__form-item">
      <label class="register-complete__label">Email</label>
      <nz-input-group>
        <input
          nz-input
          nzType="primary"
          placeholder="example@gmail.com"
          formControlName="email"
          type="email"
          class="register-complete__input beta"
          autocomplete="off"
          [ngClass]="{
            'border-error': f['email'].invalid && f['email'].touched,
          }"
        />
      </nz-input-group>
      <div
        *ngIf="f['email'].invalid && f['email'].touched"
        class="register-complete__form__error"
      >
        * Please enter a valid email
      </div>
    </div>

    <div class="register-complete__form-item">
      <label class="register-complete__label">Country</label>
      <nz-input-group>
        <nz-select
          nztype="primary"
          [formControl]="validateForm.controls.country"
          [nzCustomTemplate]="countryTemplate"
          class="register-complete__country-select"
          nzPlaceHolder="Country"
          [ngClass]="{
            'border-error': f['country'].invalid && f['country'].touched,
          }"
        >
          <nz-option
            nzCustomContent
            *ngFor="let country of countryList"
            nzValue="{{ country.code }}"
          >
            <div nz-flex nzAlign="center" nzGap="8px">
              <div [innerHTML]="country.flag" class="register-complete__flag-icon"></div>
              <span>{{ country.name }}</span>
            </div>
          </nz-option>
        </nz-select>
      </nz-input-group>

      <div
        *ngIf="f['country'].invalid && f['country'].touched"
        class="register-complete__form__error"
      >
        * Country selection is required
      </div>
    </div>

    <div class="register-complete__form-item-row">
      <div class="register-complete__form-item">
        <label class="register-complete__label">ZIP/Postal code</label>
        <nz-input-group>
          <input
            nz-input
            nztype="primary"
            placeholder="ZIP/Postal code"
            formControlName="zip"
            class="register-complete__input beta"
            [ngClass]="{
              'border-error': f['zip'].invalid && f['zip'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="f['zip'].invalid && f['zip'].touched"
          class="register-complete__form__error"
        >
          * Please entery your ZIP/Postal code
        </div>
      </div>
      <div class="register-complete__form-item">
        <label class="register-complete__label">City</label>
        <nz-input-group>
          <input
            nz-input
            nztype="primary"
            placeholder="City"
            formControlName="city"
            class="register-complete__input beta"
            [ngClass]="{
              'border-error': f['city'].invalid && f['city'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="f['city'].invalid && f['city'].touched"
          class="register-complete__form__error"
        >
          * Please enter your city
        </div>
      </div>
    </div>

    <div class="register-complete__form-item">
      <label class="register-complete__label">Address</label>
      <nz-input-group>
        <input
          nz-input
          nztype="primary"
          placeholder="Address"
          formControlName="address"
          class="register-complete__input beta"
          [ngClass]="{
            'border-error': f['address'].invalid && f['address'].touched,
          }"
        />
      </nz-input-group>
      <div
        *ngIf="f['address'].invalid && f['address'].touched"
        class="register-complete__form__error"
      >
        * Please enter your address
      </div>
    </div>

    <div class="register-complete__form-item">
      <label class="register-complete__label">Phone</label>
      <div class="register-complete__phone-input">
        <nz-select
          nztype="primary"
          [formControl]="validateForm.controls.countryCode"
          [nzCustomTemplate]="dialingCodeTemplate"
          class="register-complete__dialcode-select"
          nzPlaceHolder="Dial Code"
          [ngClass]="{
            'border-error':
              f['countryCode'].invalid && f['countryCode'].touched,
          }"
        >
          <nz-option
            nzCustomContent
            *ngFor="let country of countryList"
            nzValue="{{ country.code }}"
          >
            <div nz-flex nzAlign="center" nzGap="8px">
              <div [innerHTML]="country.flag" class="register-complete__flag-icon"></div>
              <span>{{ country.dialingCode }}</span>
            </div>
          </nz-option>
        </nz-select>

        <nz-input-group>
          <input
            nztype="primary"
            nz-input
            [placeholder]="placeholder"
            formControlName="phone"
            class="register-complete__input beta"
            [mask]="
              getPhoneMaskForCountry(
              validateForm.controls.countryCode.value
              )
            "
            [ngClass]="{
              'border-error':
                (f['phone'].invalid &&
                  f['phone'].touched &&
                  !f['phone'].hasError('invalidPhone')) ||
                (f['phone'].touched && f['phone'].hasError('invalidPhone')),
            }"
          />
        </nz-input-group>
      </div>
      <div
        *ngIf="f['countryCode'].invalid && f['countryCode'].touched"
        class="register-complete__form__error"
      >
        * Country selection is required
      </div>
      <div
        *ngIf="
          f['phone'].touched &&
          f['phone'].invalid &&
          !f['phone']?.hasError('invalidPhone')
        "
        class="register-complete__form__error"
      >
        * Phone number is required
      </div>
      <div
        *ngIf="f['phone'].touched && f['phone']?.hasError('invalidPhone')"
        class="register-complete__form__error"
      >
        Invalid phone number for selected country code.
      </div>
    </div>

    <label class="register-complete__checkbox">
      <input type="checkbox" formControlName="eula" />
      Yes, I agree to the &nbsp;
      <a href="" class="terms-and-conditions-link"> Terms & Conditions </a
      >&nbsp; and &nbsp;
      <a href="" class="official-rules-link"> Official Rules </a>
    </label>
    <div
      *ngIf="f['eula'].invalid && f['eula'].touched"
      class="register-complete__form__error"
    >
      You must agree to the terms and conditions
    </div>

    <button nz-button nzType="primary" type="submit" class="register-complete__submit">
      Register
    </button>
  </form>
</div>

<ng-template #countryTemplate let-selected>
  <div class="register-complete__select-wrapper" *ngIf="selected.nzValue">
    <div
      [innerHTML]="getFlagByCode(selected.nzValue)"
      class="register-complete__select-flag"
    ></div>
    <span>{{ getCountryNameByCode(selected.nzValue) }}</span>
  </div>
</ng-template>

<ng-template #dialingCodeTemplate let-selected>
  <div class="register-complete__select-wrapper" *ngIf="selected.nzValue">
    <div
      [innerHTML]="getFlagByCode(selected.nzValue)"
      class="register-complete__select-flag"
    ></div>
    <span>{{ getDialingCodeByCountryCode(selected.nzValue) }}</span>
  </div>
</ng-template>
